export default "__VITE_PUBLIC_ASSET__fc45f657__"